import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/RCImg6.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="A Ground mount Solar Array" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/RoofTopCanopyImages/RTCImg2.js